// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton-button-2qiGi Link-link-1rgM9","isDisabled":"IconButton-isDisabled-1NyYB"};